import { cva, cx, type VariantProps } from '@/cva.config';

const spinnerVariants = cva({
  base: 'inline-block animate-spin rounded-full border-accent border-t-transparent',
  defaultVariants: {
    size: 'md',
  },
  variants: {
    size: {
      lg: 'size-8 border-2',
      md: 'size-5 border-2',
      sm: 'size-4 border-2',
      xs: 'size-3 border',
    },
  },
});

interface SpinnerProps extends VariantProps<typeof spinnerVariants> {
  className?: string;
  label?: string;
}

export const Spinner = ({
  className,
  label = 'Loading',
  size,
}: SpinnerProps) => (
  <span
    aria-label={label}
    className={cx(spinnerVariants({ size }), className)}
    role="status"
  />
);
